import { Navigate } from "react-router-dom";

export default function RiskConfigDetailPage() {
  return <Navigate to="/forex/config/detail?pkg=risk_config" replace />;
}
